import PublicPolicyPage from '../components/layout/PublicPolicyPage';

export default function TermsConditionsPage() {
  return <PublicPolicyPage pageKey="terms" canonicalPath="/terms-and-conditions" />;
}
